/* ============
 * Mutations for the auth module
 * ============
 *
 * The mutations that are available on the
 * account module.
 */

import Vue from 'vue';
import {
  ADDTOAST,
  // REGISTER,
  // LOGIN,
  // LOGOUT,
} from './mutation-types';

/* eslint-disable no-param-reassign */
export default {
  // [CHECK](state) {
  //   state.authenticated = !!localStorage.getItem('id_token');
  //   if (state.authenticated) {
  //     Vue.$http.defaults.headers.common.Authorization = `Bearer ${localStorage.getItem('id_token')}`;
  //   }
  // },

  [ADDTOAST](state, ob) {
    //
    ob.vm.$bvToast.toast(ob.msg, {
      title : 'Error',
      variant : 'danger',
      solid : true,
     })
    // state.messages.unshift(ob.msg),
    console.log('error msg to toast',ob.msg)
  },

  // [LOGIN](state, user) {
  //   state.authenticated = true;
  //   localStorage.setItem('id_token', user.token);
  //   localStorage.setItem('user_id', user.user.uid);
  //   localStorage.setItem('user_name', user.user.uname)
  //   Vue.$http.defaults.headers.common.Authorization = `Bearer ${user.token}`;
  // },

  // [LOGOUT](state) {
  //   state.authenticated = false;
  //   localStorage.removeItem('id_token');
  //   localStorage.removeItem('user_id');
  //   localStorage.removeItem('user_name')
  //   Vue.$http.defaults.headers.common.Authorization = '';
  // },
};



// WEBPACK FOOTER //
// ./src/store/modules/toast/mutations.js